'use client'

import CopyIcon from '@/app/icons/copy'
import { FlashMessageContext } from '@/context/flash-message'
import { KeyboardEvent, useCallback, useContext } from 'react'

type Props = {
    phrase: string
}

const MemeMakerCopyPhrase = ({ phrase }: Props) => {
    const { showMessage } = useContext(FlashMessageContext)

    const copyPhrase = useCallback(async () => {
        try {
            await navigator.clipboard.writeText(phrase)
            showMessage({ message: 'Search phrase copied to clipboard', type: 'success' })
        } catch {
            showMessage({ message: 'Could not copy search phrase', type: 'error' })
        }
    }, [phrase, showMessage])

    const handleKeyDown = (event: KeyboardEvent<HTMLSpanElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            void copyPhrase()
        }
    }

    return (
        <span
            aria-label={`Copy ${phrase} to clipboard`}
            className="group inline cursor-pointer font-bold text-giphyWhite underline-offset-2 transition-colors outline-none select-text hover:text-giphyAqua focus-visible:rounded-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-giphyBlue"
            onClick={() => void copyPhrase()}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            title="Copy search phrase"
        >
            <span className="break-all">{phrase}</span>
            <CopyIcon
                aria-hidden="true"
                className="ml-1 inline-block size-3.5 fill-current align-middle opacity-70 transition-opacity group-hover:opacity-100"
            />
        </span>
    )
}

export default MemeMakerCopyPhrase
